import { useFindMissionSensorList } from "../../api/MissionEditApi"
import { useNexusProjectNumber } from "../../hooks/useNexusParams"
import { MissionEditor } from "./MissionEditor"

export const MissionEditorWrapper = () => {
    const projectNumber = useNexusProjectNumber()
    /**
     * Having the API calls in a parent component makes error handling work in an expected way
     *  - when it was in the MissionEditor component it caused a lot of re-renders
     */
    const sensorListResponse = useFindMissionSensorList(projectNumber)

    return <MissionEditor sensorListResponse={sensorListResponse} />
}
